var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7524 15.2544L7.24491 7.74683M17.5686 10.5617L19.4451 12.4382C19.9381 12.9312 20.3291 13.5164 20.5959 14.1604C20.8627 14.8045 21 15.4948 21 16.192C21 16.8891 20.8627 17.5794 20.5959 18.2235C20.3291 18.8676 19.9381 19.4528 19.4451 19.9457C18.9522 20.4387 18.367 20.8297 17.7229 21.0965C17.0788 21.3633 16.3885 21.5006 15.6914 21.5006C14.9942 21.5006 14.3039 21.3633 13.6599 21.0965C13.0158 20.8297 12.4306 20.4387 11.9376 19.9457L10.0637 18.0692M11.9389 4.93068L10.0624 3.05413C9.56944 2.56118 8.98422 2.17015 8.34015 1.90336C7.69608 1.63658 7.00576 1.49927 6.30862 1.49927C5.61149 1.49927 4.92117 1.63658 4.2771 1.90336C3.63303 2.17015 3.04781 2.56118 2.55486 3.05413C2.06191 3.54708 1.67088 4.1323 1.40409 4.77637C1.13731 5.42044 1 6.11075 1 6.80789C1 7.50503 1.13731 8.19534 1.40409 8.83941C1.67088 9.48349 2.06191 10.0687 2.55486 10.5617L4.43141 12.4382",
    stroke: "url(#paint0_linear_2571_12635)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2571_12635",
    x1: 21,
    y1: 1.49927,
    x2: 0.998674,
    y2: 21.4993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.87df594e3a1e8714061d675630b352f9.svg";
export { ForwardRef as ReactComponent };